import React from 'react';
import { usePlanningBottomupState } from '../Context/index';

export function UKRetail() {
  const { planningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { planningBottomProducts, selectedDisplayColumn } = planningBottomup;
  const ukRetailField = [
    // {
    //   keyName: "ukRetailCv",
    //   name: `${ukDisplay ? "UK " : ""}Retail CV`,
    // },
    // {
    //   keyName: "ukRetailSvNet",
    //   name: `${ukDisplay ? "UK " : ""}Retail SV Net`,
    // },
  ];

  if (ukRetailField.length === 0) {
    return null;
  }

  const isTableVisible = ukRetailField?.filter((ele) => selectedDisplayColumn?.includes(ele.keyName));
  return (
    isTableVisible.length > 0 && (
      <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
        <thead>
          <tr>
            {ukRetailField?.map((ukRetailItem, i) => {
              const isVisible = checkVisibleBottomUp(ukRetailItem.keyName);
              return (
                isVisible && (
                  <th key={i} className="w-200px">
                    <span>{ukRetailItem?.name}</span>
                  </th>
                )
              );
            })}
          </tr>
        </thead>
        <tbody>
          {(planningBottomProducts ?? [])?.map((trItem, iParent) => {
            return (
              <tr key={iParent}>
                {ukRetailField?.map((tdItem, iTD) => {
                  const isVisible = checkVisibleBottomUp(tdItem.keyName);
                  return (
                    isVisible && (
                      <td key={iTD} className="text-right">
                        {trItem[tdItem?.keyName]}
                      </td>
                    )
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
}
export default UKRetail;
